/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createInventoryItemDataSchema = z.object({
	catalogueItemId: z.string().uuid(),
	valueCents: z.number(),
	quantity: z.number(),
	description: z.string(),
	expiresAt: z.iso.datetime(),
	isInvoiced: z.boolean().optional().default(false),
	invoiceReference: z.string().nullable().optional(),
})

export type CreateInventoryItemDataSchema = z.infer<typeof createInventoryItemDataSchema>
